import CountryRepository from "./CountryRepository";
import { CountryOrganization, Country } from "./Country";

export default class CountryService {
  private readonly countryRepository: CountryRepository = new CountryRepository();

  async getCountriesByOrganization(
    organizationId: string
  ): Promise<CountryOrganization[]> {
    return this.countryRepository.getCountriesByOrganization(organizationId);
  }

  async getCountries(): Promise<Country[]> {
    return this.countryRepository.getCountries();
  }
}
